import { RouteObject } from "react-router-dom";
import { DevelopmentChangeLogPage } from "src/routes/developments/change-log/DevelopmentChangeLogPage";
import * as changeLogPaths from "src/routing/domains/developments/change-log/changeLogPaths";

/**
 * SideNav leaf routes for development change-log section.
 *
 * Role: data router domain leaves. Spread under `DevelopmentLegacySideNavLayout` in `detail/developmentDetail.tsx`.
 */
export const changeLogSideNavRoutes: RouteObject[] = [
  { path: `${changeLogPaths.developmentChangeLogRoute.path}/*`, Component: DevelopmentChangeLogPage },
];
